/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseImportOldMessageResult } from '../models/api-response-import-old-message-result';
import { importOldMessages } from '../fn/conversation-import-api/import-old-messages';
import { ImportOldMessages$Params } from '../fn/conversation-import-api/import-old-messages';

@Injectable({ providedIn: 'root' })
export class ConversationImportApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `importOldMessages()` */
  static readonly ImportOldMessagesPath = '/v1/api/ui/conversation/import-old-messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importOldMessages()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importOldMessages$Response(params: ImportOldMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportOldMessageResult>> {
    return importOldMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importOldMessages$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importOldMessages(params: ImportOldMessages$Params, context?: HttpContext): Observable<ApiResponseImportOldMessageResult> {
    return this.importOldMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportOldMessageResult>): ApiResponseImportOldMessageResult => r.body)
    );
  }

}
